module.exports = __webpack_public_path__ + "static/leather_armor-e3ca5878820d2307b21f207a5f9d5973.jpg";